import React from 'react';
import { 
  Box, 
  VStack, 
  Image, 
  HStack, 
  Icon, 
  Link,
  Heading,
  Text
} from '@chakra-ui/react';
import { FaLinkedin, FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const getCustomImageStyles = (id) => {
  switch(id) {
    case 'seema-anand':
      return {
        objectPosition: 'center -50%'
      };
    case 'anand-neelakantan':
      return {
        objectPosition: '100% center'
      };
    case 'kavita-kane':
      return {
        objectPosition: 'center -50%'
      };
    default:
      return {
        objectPosition: 'center'
      };
  }
};

const TeamMember = ({ id, name, role, bio, image, social }) => {
  const imageStyles = getCustomImageStyles(id);
  
  return (
    <Box
      background="rgba(40,24,8,0.95)"
      backdropFilter="blur(12px)"
      borderRadius="xl"
      p={{ base: 5, md: 6 }}
      borderWidth="1px"
      borderColor="rgba(255,150,50,0.12)"
      position="relative"
      overflow="hidden"
      _hover={{
        borderColor: 'rgba(255,152,0,0.35)',
        transform: 'translateY(-4px)',
        boxShadow: '0 20px 60px rgba(255,152,0,0.12)',
      }}
      transition="all 0.3s"
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        h="2px"
        bgGradient="linear(to-r, transparent, brand.500, transparent)"
      />
      <VStack spacing={{ base: 4, md: 6 }} align="start">
        <HStack spacing={{ base: 4, md: 6 }} width="100%">
          <Box
            flexShrink={0}
            width={{ base: "80px", md: "100px" }}
            height={{ base: "80px", md: "100px" }}
            borderRadius="full"
            overflow="hidden"
            border="2px solid rgba(255,152,0,0.35)"
            boxShadow="0 0 16px rgba(255,152,0,0.15)"
          >
            <Image
              src={image}
              alt={name}
              width="100%"
              height="100%"
              objectFit="cover"
              {...imageStyles}
            />
          </Box>
          <VStack align="start" spacing={1}>
            <Heading
              as="h3"
              fontSize={{ base: "lg", md: "xl" }}
              color="whiteAlpha.900"
            >
              {name}
            </Heading>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              color="brand.300"
              fontWeight="medium"
            >
              {role}
            </Text>
            <HStack spacing={3} mt={{ base: 1, md: 2 }}>
              {social.linkedin && (
                <Link
                  href={social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  _hover={{ color: 'brand.300' }}
                >
                  <Icon as={FaLinkedin} boxSize={{ base: 4, md: 5 }} />
                </Link>
              )}
              {social.twitter && (
                <Link
                  href={social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  _hover={{ color: 'brand.300' }}
                >
                  <Icon as={FaXTwitter} boxSize={{ base: 4, md: 5 }} />
                </Link>
              )}
              {social.instagram && (
                <Link
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  _hover={{ color: 'brand.300' }}
                >
                  <Icon as={FaInstagram} boxSize={{ base: 4, md: 5 }} />
                </Link>
              )}
            </HStack>
          </VStack>
        </HStack>
        <Box w="100%" h="1px" bg="rgba(255,150,50,0.1)" />
        <Text
          color="whiteAlpha.800"
          fontSize={{ base: "sm", md: "md" }}
          lineHeight="tall"
        >
          {bio}
        </Text>
      </VStack>
    </Box>
  );
};

export default TeamMember;
